/* eslint-disable */
// @ts-nocheck

export const encodeUUID = (uuid: string) => {
	if (uuid && isColdfusionID(uuid)) {
		return uuid;
	}
	if (uuid && isUUID(uuid)) {
		return UUIDToColdfusionID(uuid);
	}

	return undefined;
};

export const UUIDToColdfusionID = (uuid: string) => {
	if (!isUUID(uuid)) {
		throw new Error(`The value is not a UUID: ${uuid}`);
	}

	return `${uuid.substring(0, 23)}${uuid.substring(24)}`.toUpperCase();
};

export const isUUID = (id: string) => {
	const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

	return regex.test(id);
};

export const isColdfusionID = (id: string) => {
	// ColdfusionID format: 0879CD39-F386-4ABA-A8FC2D6B9D9C480E
	return id.length === 35 && (id.match(/-/g) || []).length === 3;
};

// http://www.ietf.org/rfc/rfc4122.txt
export const createCFID = function () {
	const s = [];
	const hexDigits = '0123456789ABCDEF';

	for (let i = 0; i < 35; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}

	s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] as boolean & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = '-';

	return s.join('');
};

export const validateUUID = (id: string) => {
	if (isUUID(id)) {
		return id;
	}

	throw new Error('Invalid UUID: ' + id);
};
